var map = {
	"./icon_ad_1.png": 2828,
	"./icon_arrow_down.png": 8936,
	"./icon_arrow_up.png": 3749,
	"./icon_chat.png": 3022,
	"./icon_computer.png": 435,
	"./icon_direction.png": 6919,
	"./icon_logo_1.png": 1696,
	"./icon_phone_big.png": 2908,
	"./icon_phone_small.png": 5134,
	"./icon_qa.png": 6477,
	"./index_bg.png": 1569
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4040;